import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Gift } from "lucide-react";

const SCELTE = [3, 6, 12, 24];

/** Regalo del piano Pro: si scegli quanti mesi, così non è sempre e per tutti un anno intero. */
export const RegalaMesi = ({ tenant, onRegala, testid }) => {
  const [mesi, setMesi] = useState(6);

  return (
    <div className="flex items-center gap-1.5">
      <select
        className="h-9 rounded-md border border-slate-700 bg-slate-950 px-2 text-xs text-slate-200"
        value={mesi}
        onChange={(e) => setMesi(Number(e.target.value))}
        data-testid={`${testid}-mesi`}
      >
        {SCELTE.map((m) => (
          <option key={m} value={m}>{m} mesi</option>
        ))}
      </select>
      <Button
        size="sm"
        className="bg-amber-500 text-slate-950 hover:bg-amber-400"
        data-testid={testid}
        onClick={() => {
          if (!window.confirm(`Regali ${mesi} mesi di piano Pro a ${tenant.name}? Gli arriva un'email che glielo comunica.`)) return;
          onRegala(mesi);
        }}
      >
        <Gift className="mr-1 h-3.5 w-3.5" /> Regala Pro
      </Button>
    </div>
  );
};
